<!-- Video de fundo -->
<video
  #videoPlayer
  class="background-video"
  muted="muted"
  playsinline="true"
  autoplay
  loop>
  <source src="/assets/movies/clip-deus-e-muito-bom.mp4" type="video/mp4" />
  Seu navegador não suporta vídeos HTML5.
</video>

<div class="header">
  <div class="header__title">Lâmina do Ativo</div>
  <div class="header__content">
    <div class="header__logo">
      <a routerLink="/pt-br/home" href>
        <ng-container *ngTemplateOutlet="logo"></ng-container>
      </a>
    </div>
    <div class="header__icon">
      <img src="/assets/images/main/logo-user.svg" alt="Logo Mercado Bitcoin" />
    </div>
  </div>
  <nav class="header__nav">
    <a
      (click)="scrollToSection('top')"
      class="header__link"
      [class.header__link--active]="tabPrincipalSelected === 'top'">
      Ativo
    </a>
    <a
      (click)="scrollToSection('artists')"
      class="header__link"
      [class.header__link--active]="tabPrincipalSelected === 'artists'">
      Artistas
    </a>
    <a
      (click)="scrollToSection('investiment')"
      class="header__link"
      [class.header__link--active]="tabPrincipalSelected === 'investiment'">
      Financeiro
    </a>
  </nav>
</div>

<div class="container">
  <section class="asset">
    <header class="asset__hero">
      <h1 class="asset__title">
        Direitos de royalties musicais
        <span class="asset__highlight">MZIC2</span>
      </h1>
      <div class="asset__tags">
        <span class="asset__tag">tokens de música</span>
        <span class="asset__tag">royalties digitais</span>
      </div>
    </header>
    <div id="top"></div>

    <div class="asset__player">
      <audio #audio>
        <source
          src="/assets/songs/luan-santana-deus-e-muito-bom.mp3"
          type="audio/mpeg" />
        Seu navegador não suporta o elemento de áudio.
      </audio>

      <button class="asset__play-button" (click)="playMusic(audio)">
        <svg viewBox="0 0 100 100" class="progress-circle">
          <circle
            class="progress-circle__background"
            cx="50"
            cy="50"
            r="45"></circle>
          <circle
            class="progress-circle__progress"
            cx="50"
            cy="50"
            r="45"
            [attr.stroke-dasharray]="progressCircleDashArray"
            [attr.stroke-dashoffset]="progressCircleDashOffset"></circle>
        </svg>

        @if (!isPlaying) {
          <mzic-svg src="assets/icons/mzic-play.svg" class="purple w14 play" />
        } @else {
          <mzic-svg src="assets/icons/mzic-pause-2.svg" class="purple w14" />
        }
      </button>

      <div class="asset__track-info">
        <div class="asset__track-title">DEUS É MUITO BOM - Ao Vivo</div>
        <div class="asset__track-artist">Luan Santana</div>
      </div>
    </div>

    <!-- prettier-ignore -->
    <article class="asset__info">
      <h2 class="asset__info-title">Sobre o ativo</h2>
      <p class="asset__info-text">
        Direitos de royalties sobre os direitos autorais da obra musical
        <strong>“DEUS É MUITO BOM”</strong>, interpretada pelo cantor
        <strong>Luan Santana</strong>
        na gravação
        <strong>“DEUS É MUITO BOM – Ao Vivo”</strong>, em que cada token representa uma parcela dos royalties futuros gerados
        pela música.
      </p>
      <p class="asset__info-text">
        Obtendo tokens, você se torna elegível para
        <strong>receber royalties</strong>,&nbsp;correspondentes à sua participação, provenientes da
        <strong>execução pública (ECAD)</strong>
        e
        <strong>reprodução</strong>
        da obra em plataformas de
        <strong>streaming</strong>
        digital, como
        <strong>Spotify, Apple Music e Youtube Music</strong>, pelos próximos
        <strong>10 anos</strong>.
      </p>
    </article>
  </section>

  <section class="offer">
    <div class="card">
      <h1 class="card__title">Detalhes da oferta</h1>

      <div class="card__row">
        <span class="card__label">Classe do ativo</span>
        <span class="card__value">Renda variável digital</span>
      </div>

      <div class="card__row">
        <span class="card__label">
          Direitos em oferta

          <div (click)="toggleTooltip(icon1, tooltip1)" #icon1>
            <mzic-svg
              class="w14 neutral-300"
              src="assets/icons/mzic-exclamation.svg"></mzic-svg>
          </div>
        </span>
        <span class="card__value">Royalties autorais</span>
      </div>

      <div class="card__row">
        <span class="card__label" style="flex: 1.2">
          % dos royalties em oferta
        </span>
        <span class="card__value card__value--highlight">18,75%</span>
      </div>

      <div class="card__row">
        <span class="card__label">
          Vencimento do ativo

          <div (click)="toggleTooltip(icon2, tooltip2)" #icon2>
            <mzic-svg
              class="w14 neutral-300"
              src="assets/icons/mzic-exclamation.svg"></mzic-svg>
          </div>
        </span>
        <span class="card__value">10 anos</span>
      </div>

      <div class="card__row">
        <span class="card__label">Tokens emitidos</span>
        <span class="card__value">2.000</span>
      </div>

      <div class="card__row">
        <span class="card__label" style="flex: 1.2">
          % de royalties por token

          <div (click)="toggleTooltip(icon3, tooltip3)" #icon3>
            <mzic-svg
              class="w14 neutral-300"
              src="assets/icons/mzic-exclamation.svg"></mzic-svg>
          </div>
        </span>
        <span class="card__value">0,0093%</span>
      </div>

      <div class="card__row">
        <span class="card__label">Valor por token</span>
        <span class="card__value card__value--currency">
          {{ 100 | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
        </span>
      </div>

      <div class="card__row">
        <span class="card__label">Valor total da oferta</span>
        <span class="card__value card__value--currency">
          {{ 200000 | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
        </span>
      </div>

      <div class="card__row">
        <span class="card__label">Lançamento da oferta</span>
        <span class="card__value">17 de Fevereiro, 2025</span>
      </div>

      <div class="card__row">
        <span class="card__label">Encerramento da oferta</span>
        <span class="card__value">17 de Agosto, 2025</span>
      </div>
    </div>
  </section>

  <section class="details">
    <div class="card">
      <h1 class="card__title">Detalhes da obra</h1>

      <div class="card__row">
        <span class="card__label">Título</span>
        <span class="card__value">DEUS É MUITO BOM</span>
      </div>

      <div class="card__row">
        <span class="card__label">Composta por</span>
        <span class="card__value" style="flex: 1.3">
          Luan Santana, Matheus Marcolino, Lucas Santos, Marco Esteves
        </span>
      </div>

      <div class="card__row">
        <span class="card__label">ISWC da obra</span>
        <span class="card__value card__value--highlight">T3163549819</span>
      </div>

      <div class="card__row">
        <span class="card__label">Registro ECAD</span>
        <span class="card__value">38233237</span>
      </div>

      <footer class="card__footer">
        <button (click)="openLyrics()" class="mz-button outline medium full">
          <mzic-svg class="w20" src="assets/icons/mzic-playlist.svg"></mzic-svg>
          Ver composição
        </button>
      </footer>
    </div>
  </section>

  <section class="revenue">
    <div class="revenue__content">
      <header class="revenue__header">
        <h2 class="revenue__title">Faturamento</h2>
        <p class="revenue__description">
          Receita em reais gerada pelo ativo em oferta, referente ao ECAD e ao
          streaming.
        </p>
      </header>
      <div class="revenue__totals">
        <div class="revenue__total">
          <h3 class="revenue__total__title">Faturamento total do ativo</h3>
          <p class="revenue__total__months">(últimos 18 meses)</p>
          <p class="revenue__amount">
            {{
              this.totalRevenue | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
            }}
          </p>
        </div>
        <div class="revenue__details">
          <div>
            <h4 class="revenue__details__title">Faturamento ECAD</h4>
            <p class="revenue__details__months">(últimos 18 meses)</p>
            <p class="revenue__details__value">
              {{
                this.totalEcadRevenue
                  | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
              }}
            </p>
          </div>
          <div>
            <h4 class="revenue__details__title">Faturamento streaming</h4>
            <p class="revenue__details__months">(últimos 18 meses)</p>
            <p class="revenue__details__value">
              {{
                this.totalStreamingRevenue
                  | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
              }}
            </p>
          </div>
        </div>
        <p class="revenue__note">
          Os valores apresentados representam a soma total das quantias
          recebidas pelo proprietário da obra a título dos direitos ofertados.
        </p>
      </div>
    </div>
  </section>

  <!-- Compositores -->
  <div class="composers">
    <div class="composers__content">
      <header>
        <h2 class="composers__title">Compositores</h2>
      </header>
      <nav class="tabs">
        @for (name of composersName; track $index) {
          <button
            class="tab"
            [class.tab--active]="composerSelected === $index"
            (click)="tabComposer($index)">
            {{ name }}
          </button>
        }
      </nav>

      @for (bio of composer.bio; track $index) {
        <p class="composers__description">
          {{ bio }}
        </p>
      }

      <h3 class="composers__highlight-title">Composições de destaque</h3>
      <div class="composers__highlights">
        @for (item of composer.compositions; track $index) {
          <div class="composers__highlight">
            <img
              [src]="composerCoverUrl + item.cover"
              [alt]="item.music"
              class="composers__highlight-image" />
            <footer class="composers__highlight-footer">
              <p class="composers__highlight-title">{{ item.music }}</p>
              <p class="composers__highlight-artist">{{ item.artistsName }}</p>
            </footer>
          </div>
        }
      </div>
    </div>
  </div>
  <!-- END Compositores -->

  <!-- Gravação oficial -->
  <div class="break-title">
    <h3 class="title-md-bold">Gravação oficial</h3>
  </div>

  <div class="player-preview">
    <div
      class="player-preview__cover"
      [style.background]="
        'url(/assets/images/cover-deus-e-muito-bom.jpeg) lightgray 50% / cover no-repeat'
      "></div>
    <div class="player-preview__info">
      <div class="player-preview__title">DEUS É MUITO BOM - Ao Vivo</div>
      <div class="player-preview__artist">Luan Santana</div>
    </div>
  </div>

  <section class="details">
    <div class="card">
      <header class="card__header" [class.expanded]="expandDetailsCard">
        <div class="card__header__title">
          <h1 class="card__title">Detalhes</h1>
          <button
            type="button"
            (click)="expandDetailsCard = !expandDetailsCard"
            class="mz-button only-icon ghost white small"
            [class.expanded]="expandDetailsCard">
            <mzic-svg src="assets/icons/mzic-arrow-up.svg"></mzic-svg>
          </button>
        </div>
      </header>

      @if (expandDetailsCard) {
        <div class="card__row">
          <span class="card__label">Título</span>
          <span class="card__value">DEUS É MUITO BOM - Ao Vivo</span>
        </div>

        <div class="card__row">
          <span class="card__label">Data de lançamento</span>
          <span class="card__value">27 de abril, 2023</span>
        </div>

        <div class="card__row">
          <span class="card__label">Gênero</span>
          <span class="card__value card__value--highlight">Sertanejo</span>
        </div>

        <div class="card__row">
          <span class="card__label">Interpretada por</span>
          <span class="card__value">Luan Santana</span>
        </div>

        <div class="card__row">
          <span class="card__label">Produzida por</span>
          <span class="card__value">Lucas Santos</span>
        </div>

        <div class="card__row">
          <span class="card__label">Gravadora</span>
          <span class="card__value">Sony Music Brasil</span>
        </div>

        <footer class="card__footer">
          <aside class="buttons__social">
            <a
              href="https://open.spotify.com/intl-pt/track/3iuC8v3WfFpMqQRg1NHDZM?si=9d18d107bb194076"
              target="_blank"
              class="buttons__social__item">
              <i><ng-container *ngTemplateOutlet="spotify"></ng-container></i>
              <span>Abrir no Spotify</span>
            </a>
            <a
              href="https://music.apple.com/us/album/deus-%C3%A9-muito-bom-ao-vivo/1713440129?i=1713440132"
              target="_blank"
              class="buttons__social__item">
              <i>
                <ng-container *ngTemplateOutlet="applemusic"></ng-container>
              </i>
              <span>Abrir no Apple Music</span>
            </a>
            <a
              href="https://youtu.be/JwNmNoWrz70?si=c8ml8uwKRVpYFfAi"
              target="_blank"
              class="buttons__social__item">
              <i><ng-container *ngTemplateOutlet="youtube"></ng-container></i>
              <span>Abrir no Youtube</span>
            </a>
          </aside>
        </footer>
      }
    </div>
  </section>
  <!-- END Gravação oficial -->

  <!-- Performance -->
  <section class="performance">
    <div class="card">
      <header class="card__header" [class.expanded]="expandPerformanceCard">
        <div class="card__header__title">
          <h1 class="card__title">Performance</h1>
          <button
            type="button"
            (click)="expandPerformanceCard = !expandPerformanceCard"
            class="mz-button only-icon ghost white small"
            [class.expanded]="expandPerformanceCard">
            <mzic-svg src="assets/icons/mzic-arrow-up.svg"></mzic-svg>
          </button>
        </div>
        @if (expandPerformanceCard) {
          <aside>
            <p class="card__description">
              Desempenho da gravação nas principais plataformas.
            </p>
          </aside>
        }
      </header>

      @if (expandPerformanceCard) {
        <div class="social">
          <header class="social__header">
            <i>
              <ng-container *ngTemplateOutlet="spotify"></ng-container>
            </i>
            Spotify
          </header>
          <div class="social__content">
            <div class="social__box">
              <div class="social__box__title">51,5M</div>
              <div class="social__box__sub">Streams totais</div>
            </div>
            <div class="social__box">
              <div class="social__box__title">2,6M</div>
              <div class="social__box__sub">Nos últimos 3 meses</div>
            </div>
          </div>
        </div>

        <div class="social">
          <header class="social__header">
            <i>
              <ng-container *ngTemplateOutlet="youtube"></ng-container>
            </i>
            Youtube
          </header>
          <div class="social__content">
            <div class="social__box">
              <div class="social__box__title">56,6M</div>
              <div class="social__box__sub">Visualizações totais</div>
            </div>
          </div>
        </div>
      }
    </div>
  </section>
  <!-- END Performance -->

  <!-- Interprete -->
  <section class="performance" id="artists">
    <div class="card">
      <header class="card__header" [class.expannded]="expandInterpreterCard">
        <div class="card__header__title">
          <h1 class="card__title">Intérprete</h1>
          <button
            type="button"
            (click)="expandInterpreterCard = !expandInterpreterCard"
            class="mz-button only-icon ghost white small"
            [class.expanded]="expandInterpreterCard">
            <mzic-svg src="assets/icons/mzic-arrow-up.svg"></mzic-svg>
          </button>
        </div>
      </header>

      @if (expandInterpreterCard) {
        <aside class="photo">
          <div
            class="photo__item-full"
            [class.photo__item--active]="interpreterSelected === 0">
            <img
              src="assets/images/cover-luan-santana.jpeg"
              alt="Luan Santana" />
          </div>
        </aside>

        <nav class="photo__title-alone">
          <h4>Luan Santana</h4>
        </nav>

        <div class="performance__content">
          <!-- prettier-ignore -->
          <p class="performance__text">
            Luan Santana, o cantor brasileiro mais premiado dos últimos 20 anos, é conhecido por sua capacidade única de inovar e se reinventar no cenário musical, levando suas músicas ao
            <strong>#1 das mais ouvidas</strong> no Brasil
            <strong>mais de 80 vezes</strong>.
          </p>
          <p class="performance__text">
            Desde 2007, conquistou uma legião de fãs com seu talento e carisma,
            tornando-se também o
            <strong>
              artista brasileiro mais buscado na história do Google
            </strong>
            .
          </p>
          <p class="performance__text">
            Ao longo de quase duas décadas, Luan
            <strong>quebrou recordes</strong>
            em vendas de discos e acumulou
            <strong>bilhões de plays</strong>
            nas plataformas digitais. Sua dedicação à música e à experiência dos
            fãs o mantém no topo, sempre buscando novas maneiras de emocionar e
            inspirar através de suas canções e performances.
          </p>
        </div>

        <header>
          <h3 class="subtitle-md">Alcance</h3>
        </header>

        <aside class="composers__social">
          @for (item of interpreter.social; track $index) {
            <div class="composers__social-item">
              <header>
                <div class="composers__social-item-title">
                  <i>
                    <ng-container
                      *ngTemplateOutlet="
                        getSocialTemplate(item.title)
                      "></ng-container>
                  </i>
                  {{ item.title }}
                </div>
                <div class="composers__social-item-link">
                  <a [href]="item.accountLink" target="_blank">
                    {{ item.accountName }}
                    <i>
                      <mzic-svg
                        class="w13 purple"
                        src="assets/icons/mzic-external-link.svg"></mzic-svg>
                    </i>
                  </a>
                </div>
              </header>
              <div class="composers__social-item-blocks">
                @for (block of item.blocks; track $index) {
                  <div class="composers__social-item-block">
                    <div class="composers__social-item-block-value">
                      {{ block.value }}
                    </div>
                    <div class="composers__social-item-block-label">
                      {{ block.label }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </aside>

        <div>
          <div class="compositions__title">Músicas de alta performance</div>

          <div class="musics">
            @for (music of interpreter.musics; track $index) {
              <div class="music">
                <header class="music__cover">
                  <img
                    [src]="composerCoverUrl + music.cover"
                    [alt]="music.name"
                    class="music__image" />
                  <div class="music__info">
                    <p class="music__info-title">{{ music.name }}</p>
                    <p class="music__info-artist">{{ music.artist }}</p>
                  </div>
                </header>
                <div class="music__social">
                  @for (block of music.social; track $index) {
                    <div class="music__social-block">
                      <div class="music__social-block__value">
                        <i>
                          <ng-container
                            *ngTemplateOutlet="
                              getSocialTemplateByIndex($index)
                            "></ng-container>
                        </i>
                        <span>{{ block.value }}</span>
                      </div>
                      <div class="music__social-block__label">
                        {{ block.label }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </section>
  <!-- END Interprete -->

  <!-- Gestora da operação -->
  <section class="operation-manager">
    <!-- Header Section -->
    <header>
      <h1 class="title-md-bold">Gestora da operação</h1>
    </header>

    <!-- Company Info Card -->
    <div class="operation-manager__card">
      <div class="operation-manager__brand">
        <div class="operation-manager__logo">
          <ng-container *ngTemplateOutlet="logo"></ng-container>
        </div>
      </div>

      <!-- prettier-ignore -->
      <div class="operation-manager__content">
        <p class="operation-manager__description">
          A MZIC é uma asset americana especializada em
          <strong>direitos musicais</strong>, dedicada a oferecer
          <strong>soluções inovadoras</strong> para a <strong>tokenização</strong> e <strong>gestão de royalties</strong>.
        </p>

        <p class="operation-manager__description">
          Como asset gestora e parceira exclusiva de infraestrutura do Mercado
          Bitcoin, a MZIC garante que todo o processo de
          <strong>tokenização e distribuição de royalties</strong>
          segue as
          <strong>melhores práticas</strong>
          do mercado.
        </p>

        <p class="operation-manager__description">
          Nosso compromisso é com a
          <strong>segurança</strong>
          e
          <strong>transparência</strong>
          em todas as transações, assegurando
          <strong>retornos consistentes</strong>
          e
          <strong>comunicação contínua</strong>
          com os investidores ao longo de todo o ciclo da oferta.
        </p>
      </div>
    </div>

    <!-- Operation Flow Section -->
    <div class="operation-flow">
      <header>
        <h2 class="operation-flow__title">Fluxo da operação</h2>
        <p class="operation-flow__subtitle">
          Entenda a parceria entre a MZIC e o MB, da curadoria à distribuição de
          royalties.
        </p>
      </header>

      <!-- Slider main container -->
      <div class="swiper">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div class="swiper-slide">
            <div class="text-center">
              <img src="/assets/images/main/flow-001.svg" alt="Flow 1" />
            </div>
            <h3>Curadoria e precificação</h3>
            <p>
              A MZIC realiza a curadoria, a análise de precificação e o
              packaging de um catálogo musical em um produto de investimento.
            </p>
          </div>
          <div class="swiper-slide">
            <div class="text-center">
              <img src="/assets/images/main/flow-002.svg" alt="Flow 2" />
            </div>
            <h3>Registro e listagem da oferta</h3>
            <p>
              Em parceria com o Mercado Bitcoin, a oferta é registrada na CVM e
              aberta para os investidores.
            </p>
          </div>
          <div class="swiper-slide">
            <div class="text-center">
              <img src="/assets/images/main/flow-003.svg" alt="Flow 3" />
            </div>
            <h3>Auditoria e coleta de royalties</h3>
            <p>
              A MZIC administra a coleta da receita de royalties autorais e
              audita os recebíveis com as entidades responsáveis.
            </p>
          </div>
          <div class="swiper-slide">
            <div class="text-center">
              <img src="/assets/images/main/flow-004.svg" alt="Flow 4" />
            </div>
            <h3>Distribuição de dividendos</h3>
            <p>
              Trimestralmente, a MZIC presta contas e transfere os dividendos
              para o Mercado Bitcoin, que os repassa aos investidores.
            </p>
          </div>
        </div>
        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </section>
  <!-- END Gestora da operação -->

  <!-- Fluxo dos royalties -->
  <section class="flow-royalties">
    <div>
      <h1 class="title-md-bold">Fluxo dos royalties</h1>
    </div>

    <div class="operation-flow operation-flow--bg-600 operation-flow--with-mb">
      <header>
        <h2 class="operation-flow__label">FONTE DE RECEITA (1 de 2)</h2>
        <h2 class="operation-flow__title">
          Royalties de execução pública

          <span (click)="toggleTooltip(icon4, tooltip4)" #icon4>
            <mzic-svg
              class="w14"
              style="color: #e6e6ea"
              src="assets/icons/mzic-exclamation.svg"></mzic-svg>
          </span>
        </h2>
      </header>

      <!-- Slider main container -->
      <div class="swiper">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <!-- prettier-ignore -->
          <div class="swiper-slide">
            <div class="text-center">
            <img src="/assets/images/main/royalties-001.svg" alt="Flow 1" />
            </div>
            <h3>Coleta e repasse às associações</h3>
            <p>
              O ECAD taxa o uso comercial da obra e repassa os valores às
              associações de gestão coletiva

              <span (click)="toggleTooltip(icon6, tooltip6, true)" #icon6>
              <mzic-svg
                class="w14 neutral-300"
                style="top: 3px"
                src="assets/icons/mzic-exclamation.svg"></mzic-svg></span>, de acordo com as rubricas aplicáveis
              <span (click)="toggleTooltip(icon7, tooltip7, true)" #icon7>
                <mzic-svg
                class="w14 neutral-300"
                style="top: 3px"
                src="assets/icons/mzic-exclamation.svg"></mzic-svg></span>.
            </p>
          </div>
          <div class="swiper-slide">
            <div class="text-center">
              <img src="/assets/images/main/royalties-002.svg" alt="Flow 2" />
            </div>
            <h3>Recebimento dos royalties</h3>
            <p>
              A receita é repassada à conta da MZIC - e dos demais titulares de
              direitos - na associação, de acordo com o calendário de pagamento
              do ECAD.
            </p>
          </div>
          <div class="swiper-slide">
            <div class="text-center">
              <img src="/assets/images/main/royalties-003.svg" alt="Flow 3" />
            </div>
            <h3>Auditoria e pagamento</h3>
            <p>
              Trimestralmente, a MZIC audita as receitas com a associação e
              realiza o pagamento dos royalties ao Mercado Bitcoin.
            </p>
          </div>
        </div>
        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>

    <div class="operation-flow operation-flow--bg-600">
      <header>
        <h2 class="operation-flow__label">FONTE DE RECEITA (2 de 2)</h2>
        <h2 class="operation-flow__title" style="max-width: inherit">
          Royalties de
          <br />
          streaming
          <span (click)="toggleTooltip(icon5, tooltip5)" #icon5>
            <mzic-svg
              class="w14"
              style="color: #e6e6ea"
              src="assets/icons/mzic-exclamation.svg"></mzic-svg>
          </span>
        </h2>
      </header>

      <!-- Slider main container -->
      <div class="swiper">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div class="swiper-slide">
            <div class="text-center">
              <img src="/assets/images/main/royalties-2-001.svg" alt="Flow 1" />
            </div>
            <h3>Repasse à intermediária digital</h3>
            <p>
              As plataformas de streaming repassam a receita gerada por cada
              execução à intermediária digital, de acordo com seu calendário de
              pagamento.
            </p>
          </div>
          <div class="swiper-slide">
            <div class="text-center">
              <img src="/assets/images/main/royalties-2-002.svg" alt="Flow 2" />
            </div>
            <h3>Recebimento dos royalties</h3>
            <p>
              A intermediária digital repassa os fundos à MZIC e aos demais
              titulares de direitos, conforme os percentuais contratuais.
            </p>
          </div>
          <div class="swiper-slide">
            <div class="text-center">
              <img src="/assets/images/main/royalties-2-003.svg" alt="Flow 3" />
            </div>
            <h3>Auditoria e pagamento</h3>
            <p>
              Trimestralmente, a MZIC audita as receitas com a intermediária
              digital e realiza o pagamento dos royalties ao Mercado Bitcoin.
            </p>
          </div>
        </div>
        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </section>
  <!-- END Fluxo dos royalties -->

  <!-- FINANÇAS  -->
  <section class="finance-container" id="investiment">
    <!-- Projeção de retorno -->
    <section class="sales-history">
      <div>
        <h1 class="title-md-bold">Panorama financeiro</h1>
      </div>

      <div class="card">
        <header>
          <h1 class="card__title" style="margin: 0">Evolução da receita</h1>
          <p class="card__description" style="margin: 8px 0 32px 0">
            Análise temporal dos ganhos gerados pelo ativo, referente ao ECAD e
            streaming.
          </p>
        </header>

        @if (UIFilteredData) {
          <mzic-select-simple
            ngDefaultControl
            placeholder="Selecione um período..."
            style="margin-bottom: 32px"
            [(ngModel)]="yearSelected"
            (ngModelChange)="changeRevenueYear($event)">
            <mzic-select-simple-option value="0" title="Desde o lançamento" />

            @for (year of yearsToFilter; track $index) {
              <mzic-select-simple-option
                [value]="year.id"
                [title]="year.info.title" />
            }
          </mzic-select-simple>

          <div class="total-from-period">
            <h3 class="revenue__total__title">Faturamento total do período</h3>
            <h1 class="revenue__amount">
              {{
                UIFilteredData.accumulated.total
                  | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
              }}
            </h1>
          </div>

          <div class="area-chart-container">
            <ejs-chart
              id="area-chart-container"
              [chartArea]="areaChartConfig"
              [primaryXAxis]="areaChartPrimaryXAxis"
              [primaryYAxis]="areaChartPrimaryYAxis"
              [zoomSettings]="areaChartZoomSettings"
              [tooltip]="areaChartTooltip"
              (load)="load($event)"
              title="."
              [titleStyle]="{ color: 'transparent' }"
              (axisLabelRender)="areaChartHandleAxisValue($event)"
              (tooltipRender)="areaChartTooltipRender($event)">
              <e-series-collection>
                <e-series
                  [dataSource]="areaChartData"
                  [border]="areaChartXBorder"
                  [marker]="areaChartMarker"
                  [animation]="{ enable: false }"
                  type="Area"
                  fill="url(#chart-gradient)"
                  xName="x"
                  yName="y"></e-series>
              </e-series-collection>
            </ejs-chart>

            <svg>
              <defs>
                <linearGradient
                  id="chart-gradient"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%">
                  <stop
                    offset="0%"
                    style="stop-color: rgba(150, 85, 255, 0.5)" />
                  <stop
                    offset="50%"
                    style="stop-color: rgba(150, 85, 255, 0.1)" />
                  <stop
                    offset="100%"
                    style="stop-color: rgba(150, 85, 255, 0)" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <header>
            <h1 class="card__title medium-size" style="margin-bottom: 16px">
              Faturamento ECAD x Streaming
            </h1>
          </header>

          <div class="donut-chart-container">
            <header>
              <div class="ecad">
                <div class="label">
                  <span></span>
                  ECAD
                </div>
                <div class="values">
                  {{
                    !UIFilteredData.accumulated.ecad.total
                      ? '-'
                      : (UIFilteredData.accumulated.ecad.total
                        | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR')
                  }}
                </div>
              </div>

              <div class="streaming">
                <div class="label">
                  <span></span>
                  Streaming
                </div>
                <div class="values">
                  {{
                    !UIFilteredData.accumulated.streaming.total
                      ? '-'
                      : (UIFilteredData.accumulated.streaming.total
                        | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR')
                  }}
                </div>
              </div>
            </header>

            <ejs-accumulationchart
              [enableSmartLabels]="true"
              width="100%"
              height="234"
              id="doughnot-chart">
              <e-accumulation-series-collection>
                <e-accumulation-series
                  radius="100%"
                  [dataSource]="doughnotData"
                  [dataLabel]="doughnotDatalabel"
                  xName="x"
                  yName="y"
                  innerRadius="40%"
                  [palettes]="['#8D34F9', '#552AB7']"></e-accumulation-series>
              </e-accumulation-series-collection>
            </ejs-accumulationchart>
          </div>

          <header>
            <h1 class="card__title medium-size" style="margin-bottom: 8px">
              Análise detalhada
            </h1>
          </header>

          <div class="detailed-analysis">
            <nav>
              <button
                #ecadAnalysis
                [class.active]="detailedAnalysisView === 'ecad'"
                (click)="changeDetailedAnalysis('ecad')">
                Execução Pública - ECAD
              </button>
              <button
                #streamingAnalysis
                [class.active]="detailedAnalysisView === 'streaming'"
                (click)="changeDetailedAnalysis('streaming')">
                Streaming
              </button>
            </nav>

            <div class="content">
              <header>
                @if (detailedAnalysisView === 'ecad') {
                  <div class="average">
                    <h4>Média por fonte</h4>
                    <p class="value">
                      {{
                        !UIFilteredData.accumulated.ecad.total
                          ? '-'
                          : (UIFilteredData.accumulated.ecad.total /
                              UIFilteredData.accumulated.ecad.sources.length
                            | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR')
                      }}
                    </p>
                  </div>
                } @else {
                  <div class="average">
                    <h4>Média por plataforma</h4>
                    <p class="value">
                      {{
                        !UIFilteredData.accumulated.streaming.total
                          ? '-'
                          : (UIFilteredData.accumulated.streaming.total /
                              UIFilteredData.accumulated.streaming.plataforms
                                .length
                            | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR')
                      }}
                    </p>
                  </div>
                }

                <div class="average">
                  <h4>
                    {{
                      detailedAnalysisView === 'ecad' ? 'Fontes' : 'Plataformas'
                    }}
                  </h4>
                  <p class="value" style="text-align: right">
                    {{
                      detailedAnalysisView === 'ecad'
                        ? UIFilteredData.accumulated.ecad.sources.length
                        : UIFilteredData.accumulated.streaming.plataforms.length
                    }}
                  </p>
                </div>
              </header>

              <ul class="table">
                @if (detailedAnalysisView === 'ecad') {
                  @for (
                    source of UIFilteredData.accumulated.ecad.sources
                      | slice: 0 : 4;
                    track $index
                  ) {
                    <li class="item">
                      <p class="name">{{ source.name }}</p>
                      <p class="value">
                        {{
                          source.value
                            | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
                        }}
                      </p>
                      <p class="percentage">{{ source.percentage }}%</p>
                    </li>
                  } @empty {
                    <p class="empty-label">Não contém registros disponíveis.</p>
                  }
                } @else {
                  @for (
                    plataform of UIFilteredData.accumulated.streaming.plataforms
                      | slice: 0 : 4;
                    track $index
                  ) {
                    <li class="item">
                      <p class="name">{{ plataform.name }}</p>
                      <p class="value">
                        {{
                          plataform.value
                            | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
                        }}
                      </p>
                      <p class="percentage">{{ plataform.percentage }}%</p>
                    </li>
                  } @empty {
                    <p class="empty-label">Não contém registros disponíveis.</p>
                  }
                }
              </ul>

              @if (
                (detailedAnalysisView === 'ecad' &&
                  UIFilteredData.accumulated.ecad.sources.length > 4) ||
                (detailedAnalysisView === 'streaming' &&
                  UIFilteredData.accumulated.streaming.plataforms.length > 4)
              ) {
                <button (click)="seeDetailedModal()" class="mz-button small">
                  <mzic-svg src="assets/icons/mzic-plus.svg" />
                  Ver mais
                </button>
              }
            </div>
          </div>
        }

        <p class="explanation">
          Os valores apresentados correspondem à soma de todos os valores
          recebidos por todos os detentores de direitos da obra.
        </p>
      </div>
    </section>
    <!-- END Histórico de faturamento -->

    <!-- Payment calendar -->
    <section class="calendar">
      <div class="card">
        <header>
          <h1 class="card__title" style="margin: 0">
            Calendário de pagamentos
          </h1>
          <p class="card__description" style="margin: 8px 0 24px 0">
            Pagamentos {{ frequencyPlural }} aos detentores dos tokens,
            correspondentes às receitas geradas.
          </p>
        </header>
        <div class="payment-cycle">
          <div class="payment-cycle__divided">
            <div class="payment-cycle__left">
              <div class="payment-cycle__title">
                Primeiro
                <br />
                pagamento
              </div>
              <div class="payment-cycle__left__value">
                {{
                  calendar.firstPaymentDate | date: 'MMMM yyyy' : '' : 'pt-BR'
                }}
              </div>
            </div>
            <div class="payment-cycle__right">
              <div class="payment-cycle__title">
                Ciclo de
                <br />
                pagamentos
              </div>
              <div class="payment-cycle__right__value">
                {{ frequency }}
              </div>
            </div>
          </div>
          <div class="payment-cycle__full">
            <div class="payment-cycle__title">
              Expectativa do próximo pagamento
            </div>
            <div class="payment-cycle__full__value">
              {{ calendar.firstPaymentDate | nextPayment: 10 : 'semiannual' }}
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- END Payment calendar -->

    <mzic-investment-simulation-section
      [data]="
        interpreter.investimentSimulationSectionData
      "></mzic-investment-simulation-section>
  </section>
</div>

<footer class="footer">
  <div class="footer__block">
    <a class="footer__link" [routerLink]="['/pt-br/home']">
      ACESSE NOSSO SITE
      <i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none">
          <path
            d="M9.84 2.60847L0.912 11.5205L0 10.6245L8.944 1.69647H2.576V0.480469H10.16L11.072 1.37647V8.96047H9.84V2.60847Z"
            fill="#9655FF" />
        </svg>
      </i>
    </a>
  </div>

  <div class="footer__block">
    <h5 class="footer__title">LEGAL</h5>
    <a class="footer__link" href="{{ legalUrl }}/pt-br/terms" target="_blank">
      TERMOS & CONDIÇÕES
    </a>
    <a class="footer__link" href="{{ legalUrl }}/pt-br/privacy" target="_blank">
      POLÍTICA DE PRIVACIDADE
    </a>
  </div>

  <div class="footer__block">
    <h5 class="footer__title">SIGA-NOS</h5>

    <aside class="footer__block__social">
      <a
        class="footer__link"
        href="https://discord.gg/jGfy2WQyPx"
        target="_blank">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="18"
          viewBox="0 0 24 18"
          fill="none">
          <path
            d="M19.98 2.16924C18.0693 0.631736 15.0468 0.371111 14.9175 0.361736C14.7168 0.344861 14.5256 0.457361 14.4431 0.642986C14.4356 0.654236 14.37 0.806111 14.2968 1.04236C15.5606 1.25611 17.1131 1.68549 18.5175 2.55736C18.7425 2.69611 18.8118 2.99236 18.6731 3.21736C18.5812 3.36549 18.4256 3.44611 18.2643 3.44611C18.1781 3.44611 18.09 3.42174 18.0112 3.37299C15.5962 1.87486 12.5812 1.79986 12 1.79986C11.4187 1.79986 8.40184 1.87486 5.98871 3.37299C5.76371 3.51361 5.46746 3.44424 5.32871 3.21924C5.18809 2.99236 5.25746 2.69799 5.48246 2.55736C6.88684 1.68736 8.43934 1.25611 9.70309 1.04424C9.62996 0.806111 9.56434 0.656111 9.55871 0.642986C9.47434 0.457361 9.28496 0.341111 9.08246 0.361736C8.95309 0.371111 5.93059 0.631736 3.99371 2.18986C2.98309 3.12549 0.959961 8.59299 0.959961 13.3199C0.959961 13.4042 0.982461 13.4849 1.02371 13.558C2.41871 16.0105 6.22684 16.6517 7.09496 16.6799C7.09871 16.6799 7.10434 16.6799 7.10996 16.6799C7.26371 16.6799 7.40809 16.6067 7.49809 16.483L8.37559 15.2755C6.00746 14.6642 4.79809 13.6255 4.72871 13.5636C4.52996 13.3892 4.51121 13.0855 4.68746 12.8867C4.86184 12.688 5.16559 12.6692 5.36434 12.8436C5.39246 12.8699 7.61996 14.7599 12 14.7599C16.3875 14.7599 18.615 12.8624 18.6375 12.8436C18.8362 12.6711 19.1381 12.688 19.3143 12.8886C19.4887 13.0874 19.47 13.3892 19.2712 13.5636C19.2018 13.6255 17.9925 14.6642 15.6243 15.2755L16.5018 16.483C16.5918 16.6067 16.7362 16.6799 16.89 16.6799C16.8956 16.6799 16.9012 16.6799 16.905 16.6799C17.7731 16.6517 21.5812 16.0105 22.9762 13.558C23.0175 13.4849 23.04 13.4042 23.04 13.3199C23.04 8.59299 21.0168 3.12549 19.98 2.16924ZM8.87996 11.3999C7.95184 11.3999 7.19996 10.5411 7.19996 9.47986C7.19996 8.41861 7.95184 7.55986 8.87996 7.55986C9.80809 7.55986 10.56 8.41861 10.56 9.47986C10.56 10.5411 9.80809 11.3999 8.87996 11.3999ZM15.12 11.3999C14.1918 11.3999 13.44 10.5411 13.44 9.47986C13.44 8.41861 14.1918 7.55986 15.12 7.55986C16.0481 7.55986 16.8 8.41861 16.8 9.47986C16.8 10.5411 16.0481 11.3999 15.12 11.3999Z"
            fill="white" />
        </svg>
      </a>
      <a
        class="footer__link"
        href="https://www.instagram.com/mzicbrasil"
        target="_blank">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none">
          <g clip-path="url(#clip0_515_4602)">
            <path
              d="M13.806 3.114C13.5924 3.114 13.3836 3.17734 13.206 3.29601C13.0284 3.41468 12.89 3.58336 12.8082 3.7807C12.7265 3.97805 12.7051 4.1952 12.7468 4.4047C12.7884 4.6142 12.8913 4.80663 13.0423 4.95768C13.1934 5.10872 13.3858 5.21158 13.5953 5.25325C13.8048 5.29492 14.022 5.27353 14.2193 5.19179C14.4166 5.11005 14.5853 4.97162 14.704 4.79402C14.8227 4.61641 14.886 4.4076 14.886 4.194C14.886 3.90757 14.7722 3.63286 14.5697 3.43032C14.3671 3.22779 14.0924 3.114 13.806 3.114ZM17.946 5.292C17.9285 4.54527 17.7886 3.80646 17.532 3.105C17.3032 2.50482 16.947 1.96135 16.488 1.512C16.0423 1.05068 15.4976 0.696759 14.895 0.477C14.1954 0.212545 13.4558 0.069489 12.708 0.0539999C11.754 -5.02914e-08 11.448 0 9 0C6.552 0 6.246 -5.02914e-08 5.292 0.0539999C4.54424 0.069489 3.80461 0.212545 3.105 0.477C2.50351 0.698984 1.95924 1.0526 1.512 1.512C1.05068 1.95766 0.696759 2.5024 0.477 3.105C0.212545 3.80461 0.069489 4.54424 0.0539999 5.292C-5.02914e-08 6.246 0 6.552 0 9C0 11.448 -5.02914e-08 11.754 0.0539999 12.708C0.069489 13.4558 0.212545 14.1954 0.477 14.895C0.696759 15.4976 1.05068 16.0423 1.512 16.488C1.95924 16.9474 2.50351 17.301 3.105 17.523C3.80461 17.7875 4.54424 17.9305 5.292 17.946C6.246 18 6.552 18 9 18C11.448 18 11.754 18 12.708 17.946C13.4558 17.9305 14.1954 17.7875 14.895 17.523C15.4976 17.3032 16.0423 16.9493 16.488 16.488C16.949 16.0403 17.3055 15.4964 17.532 14.895C17.7886 14.1935 17.9285 13.4547 17.946 12.708C17.946 11.754 18 11.448 18 9C18 6.552 18 6.246 17.946 5.292ZM16.326 12.6C16.3194 13.1713 16.216 13.7373 16.02 14.274C15.8763 14.6657 15.6455 15.0196 15.345 15.309C15.0531 15.6065 14.6999 15.8368 14.31 15.984C13.7733 16.18 13.2073 16.2834 12.636 16.29C11.736 16.335 11.403 16.344 9.036 16.344C6.669 16.344 6.336 16.344 5.436 16.29C4.8428 16.3011 4.25214 16.2098 3.69 16.02C3.3172 15.8653 2.98022 15.6355 2.7 15.345C2.40128 15.0559 2.17336 14.7017 2.034 14.31C1.81427 13.7656 1.6924 13.1867 1.674 12.6C1.674 11.7 1.62 11.367 1.62 9C1.62 6.633 1.62 6.3 1.674 5.4C1.67803 4.81595 1.78466 4.23715 1.989 3.69C2.14744 3.31012 2.39064 2.97149 2.7 2.7C2.97343 2.39055 3.31136 2.14479 3.69 1.98C4.2386 1.78204 4.8168 1.67857 5.4 1.674C6.3 1.674 6.633 1.62 9 1.62C11.367 1.62 11.7 1.62 12.6 1.674C13.1713 1.68055 13.7373 1.78402 14.274 1.98C14.683 2.13179 15.0501 2.37856 15.345 2.7C15.6399 2.97646 15.8704 3.31446 16.02 3.69C16.22 4.23804 16.3236 4.8166 16.326 5.4C16.371 6.3 16.38 6.633 16.38 9C16.38 11.367 16.371 11.7 16.326 12.6ZM9 4.383C8.08723 4.38478 7.19547 4.65707 6.43739 5.16548C5.67931 5.67388 5.08894 6.39558 4.74087 7.23938C4.3928 8.08318 4.30265 9.01122 4.48181 9.90624C4.66098 10.8013 5.10141 11.6231 5.74747 12.2679C6.39352 12.9127 7.21621 13.3515 8.11157 13.5289C9.00694 13.7064 9.9348 13.6144 10.7779 13.2647C11.621 12.915 12.3416 12.3232 12.8485 11.5641C13.3554 10.8051 13.626 9.91277 13.626 9C13.6272 8.39259 13.5083 7.79095 13.2761 7.22966C13.0439 6.66838 12.7031 6.15853 12.2732 5.72945C11.8433 5.30036 11.3328 4.96051 10.771 4.72944C10.2093 4.49836 9.6074 4.38063 9 4.383ZM9 11.997C8.40725 11.997 7.82781 11.8212 7.33496 11.4919C6.8421 11.1626 6.45797 10.6945 6.23113 10.1469C6.0043 9.59927 5.94495 8.99668 6.06059 8.41531C6.17623 7.83395 6.46166 7.29994 6.8808 6.8808C7.29994 6.46166 7.83395 6.17623 8.41531 6.06059C8.99668 5.94495 9.59927 6.0043 10.1469 6.23113C10.6945 6.45797 11.1626 6.8421 11.4919 7.33496C11.8212 7.82781 11.997 8.40725 11.997 9C11.997 9.39357 11.9195 9.78329 11.7689 10.1469C11.6183 10.5105 11.3975 10.8409 11.1192 11.1192C10.8409 11.3975 10.5105 11.6183 10.1469 11.7689C9.78329 11.9195 9.39357 11.997 9 11.997Z"
              fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_515_4602">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
    </aside>
  </div>

  <aside class="footer__rights">
    <div>MZIC © ALL RIGHTS RESERVED</div>
    <div class="footer__logo">
      <ng-container *ngTemplateOutlet="logo"></ng-container>
    </div>
  </aside>
</footer>

<!-- CTA button -->
<button (click)="scrollToSection('simulator')" class="cta-button">
  Simule o seu investimento aqui e realize sua aplicação
</button>

<!-- Logo da empresa -->
<ng-template #logo>
  <svg viewBox="0 0 94 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M45.5263 19.581V4.9967L39.7263 19.581H37.0259L31.2259 5.02741V19.581H28.2261V0.418945H32.0773L38.3894 16.2755L44.6749 0.418945H48.5261V19.581H45.5263Z"
      fill="#EDEDED" />
    <path
      d="M51.4549 19.581V16.7405L62.2988 3.0511H51.9626V0.418945H65.6866V3.26167L54.8426 16.9489H65.9704V19.581H51.4549Z"
      fill="#EDEDED" />
    <path
      d="M71.8967 0.418945H68.8969V19.5832H71.8967V0.418945Z"
      fill="#EDEDED" />
    <path
      d="M84.5653 20C78.6478 20 74.8233 16.0518 74.8233 9.94297C74.8233 3.83417 78.7387 0 84.5653 0C89.4984 0 92.9527 2.82737 93.8462 7.57403H90.7622C90.0815 4.52073 87.7203 2.63216 84.5653 2.63216C80.5213 2.63216 77.9095 5.50121 77.9095 9.94297C77.9095 14.3847 80.4592 17.3393 84.5653 17.3393C87.7779 17.3393 90.0837 15.5056 90.7622 12.4238H93.844C92.9017 17.2428 89.5317 19.9978 84.5653 19.9978V20Z"
      fill="#EDEDED" />
    <path
      d="M0 19.581V7.53893H2.99976V14.5163L14.2494 3.3867H0V0.418945H19.371L19.3687 12.4611H16.369V5.48585L5.12154 16.6133H19.371V19.581H0Z"
      fill="#EDEDED" />
  </svg>
</ng-template>
<!-- END Logo da empresa -->

<!-- Logo empresas -->
<ng-template #spotify>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_144_7253)">
      <circle cx="10" cy="9.99984" r="8.33333" fill="black" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9 8.89999C12.7 6.99999 7.35 6.8 4.3 7.75C3.8 7.9 3.3 7.6 3.15 7.15C3 6.65 3.3 6.15 3.75 6C7.3 4.95 13.15 5.15001 16.85 7.35001C17.3 7.60001 17.45 8.2 17.2 8.65C16.95 9 16.35 9.14999 15.9 8.89999ZM15.8 11.7C15.55 12.05 15.1 12.2 14.75 11.95C12.05 10.3 7.95 9.8 4.8 10.8C4.4 10.9 3.95 10.7 3.85 10.3C3.75 9.9 3.95 9.45 4.35 9.35C8 8.25 12.5 8.8 15.6 10.7C15.9 10.85 16.05 11.35 15.8 11.7ZM14.6 14.45C14.4 14.75 14.05 14.85 13.75 14.65C11.4 13.2 8.45 12.9 4.95 13.7C4.6 13.8 4.3 13.55 4.2 13.25C4.1 12.9 4.35 12.6 4.65 12.5C8.45 11.65 11.75 12 14.35 13.6C14.7 13.75 14.75 14.15 14.6 14.45ZM10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.55 0 10 0Z"
        fill="#1ED760" />
    </g>
    <defs>
      <clipPath id="clip0_144_7253">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #applemusic>
  <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_144_7258)">
      <g clip-path="url(#clip1_144_7258)">
        <path
          d="M20.571 9.95217C20.571 4.45574 16.1153 0 10.6189 0C5.12243 0 0.666687 4.45574 0.666687 9.95217C0.666687 15.4486 5.12243 19.9043 10.6189 19.9043C16.1153 19.9043 20.571 15.4486 20.571 9.95217Z"
          fill="url(#paint0_linear_144_7258)" />
        <path
          d="M15.4973 7.75701C15.4973 7.45972 15.4722 7.16364 15.4013 6.8742C15.2739 6.34699 14.9736 5.94427 14.5241 5.64849C14.2929 5.49742 14.0385 5.40466 13.768 5.35572C13.5604 5.31794 13.35 5.30072 13.1393 5.2959C13.1236 5.29438 13.1064 5.29107 13.0889 5.28955H8.25011C8.18885 5.29438 8.12756 5.2974 8.0663 5.30042C7.76598 5.31766 7.46745 5.34907 7.18432 5.46238C6.64676 5.67477 6.25828 6.04607 6.03191 6.58114C5.95343 6.76212 5.91389 6.95396 5.88582 7.14914C5.86228 7.30655 5.84961 7.46546 5.84506 7.62438C5.84506 7.63707 5.84204 7.64946 5.84204 7.66214V12.5859C5.84506 12.6427 5.84839 12.6992 5.85141 12.756C5.87193 13.085 5.91419 13.4107 6.05274 13.7128C6.31382 14.2841 6.75239 14.66 7.35456 14.8409C7.52269 14.8929 7.69895 14.9165 7.87493 14.9322C8.0983 14.9542 8.32135 14.9573 8.54471 14.9573H12.9841C13.1948 14.9573 13.4055 14.9431 13.6162 14.9165C13.9479 14.8739 14.2591 14.7763 14.5407 14.5908C14.8788 14.3672 15.1335 14.0714 15.2968 13.7016C15.3723 13.5316 15.4149 13.3509 15.4463 13.1681C15.4918 12.8959 15.5012 12.6203 15.5012 12.3451C15.4997 10.8154 15.5012 9.28607 15.4997 7.7564L15.4973 7.75701ZM12.9126 9.36342V11.6641C12.9126 11.8324 12.8891 11.9976 12.8136 12.1502C12.6974 12.3877 12.5088 12.5372 12.2555 12.6097C12.1155 12.6506 11.9709 12.6726 11.8248 12.6789C11.4427 12.698 11.1109 12.4381 11.0433 12.0605C10.9851 11.749 11.1345 11.4058 11.4614 11.2454C11.5903 11.1825 11.7303 11.1447 11.8701 11.1164C12.0225 11.0834 12.1749 11.0535 12.3258 11.0188C12.4375 10.9937 12.5097 10.926 12.5317 10.8109C12.538 10.7858 12.5395 10.7589 12.5395 10.7339C12.5395 10.0021 12.5395 9.27035 12.5395 8.54042C12.5395 8.51535 12.5347 8.48996 12.5287 8.4664C12.513 8.40507 12.4689 8.36881 12.4061 8.37183C12.3415 8.37486 12.2788 8.38603 12.216 8.39872C11.9093 8.45855 11.6029 8.51988 11.2978 8.58273L9.80911 8.88333C9.80278 8.88486 9.79493 8.88818 9.78858 8.88818C9.67691 8.91959 9.63767 8.97005 9.63285 9.08636C9.63132 9.10359 9.63285 9.12112 9.63285 9.13833C9.63132 10.1864 9.63285 11.2345 9.63132 12.2822C9.63132 12.4524 9.61232 12.6191 9.545 12.7762C9.43332 13.0342 9.23532 13.1965 8.96819 13.2735C8.82663 13.3143 8.68204 13.3382 8.53415 13.3427C8.149 13.3569 7.82815 13.1004 7.76235 12.7212C7.70561 12.394 7.85502 12.0415 8.22598 11.8841C8.37054 11.8242 8.51995 11.7913 8.67239 11.7599C8.78708 11.7363 8.90361 11.7127 9.0183 11.6892C9.17224 11.6562 9.25252 11.5587 9.26037 11.4012V11.3414C9.26037 10.1486 9.26037 8.95586 9.26037 7.76305C9.26037 7.71259 9.26671 7.66244 9.27758 7.61351C9.30595 7.4987 9.38774 7.43253 9.49761 7.40564C9.59993 7.37875 9.70528 7.36003 9.8088 7.33796C10.1043 7.27814 10.3983 7.21831 10.6938 7.16001L11.6072 6.9742C11.8776 6.92072 12.1463 6.86575 12.4167 6.81227C12.5048 6.79505 12.5945 6.77601 12.6838 6.76966C12.8079 6.75879 12.8945 6.83733 12.9072 6.96333C12.9102 6.99325 12.912 7.02316 12.912 7.05305V9.36159L12.9126 9.36342Z"
          fill="white" />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_144_7258"
        x1="10.6189"
        y1="0"
        x2="10.6189"
        y2="19.9043"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FB5971" />
        <stop offset="1" stop-color="#FA253D" />
      </linearGradient>
      <clipPath id="clip0_144_7258">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.666687)" />
      </clipPath>
      <clipPath id="clip1_144_7258">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.666687)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #youtube>
  <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_144_7263)">
      <rect
        width="8.33333"
        height="7.5"
        transform="translate(6.16669 6.6665)"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.1586 3.76183C19.0153 3.99243 19.6908 4.6679 19.9214 5.52456C20.3498 7.08963 20.3333 10.3516 20.3333 10.3516C20.3333 10.3516 20.3333 13.597 19.9214 15.1621C19.6908 16.0188 19.0153 16.6942 18.1586 16.9248C16.5936 17.3367 10.3333 17.3367 10.3333 17.3367C10.3333 17.3367 4.0895 17.3367 2.50797 16.9083C1.65131 16.6777 0.975874 16.0023 0.745234 15.1456C0.333374 13.597 0.333374 10.3351 0.333374 10.3351C0.333374 10.3351 0.333374 7.08963 0.745234 5.52456C0.975874 4.6679 1.66777 3.97596 2.50797 3.7453C4.07304 3.3335 10.3333 3.3335 10.3333 3.3335C10.3333 3.3335 16.5936 3.3335 18.1586 3.76183ZM13.5458 10.3351L8.3399 13.3334V7.33676L13.5458 10.3351Z"
        fill="#FF0000" />
    </g>
    <defs>
      <clipPath id="clip0_144_7263">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.333374)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #instagram>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_193_33980)">
      <path
        d="M4.05725 16.4434C3.43839 16.4365 2.82534 16.323 2.24502 16.1078C1.82125 15.9512 1.43784 15.7018 1.12282 15.378C0.798081 15.0636 0.548342 14.6801 0.392157 14.2559C0.177216 13.6756 0.0638717 13.0626 0.057098 12.4438C0.00956863 11.4151 0 11.1066 0 8.5C0 5.89341 0.0105098 5.58596 0.0566274 4.55647C0.0642231 3.93793 0.177707 3.32525 0.392157 2.74502C0.549103 2.32118 0.798488 1.93761 1.1222 1.6222C1.43682 1.29775 1.82041 1.04824 2.24455 0.892157C2.82487 0.677038 3.43792 0.563534 4.05678 0.556627C5.0858 0.509569 5.39482 0.5 8 0.5C10.6052 0.5 10.914 0.51051 11.9435 0.556627C12.5622 0.564169 13.1751 0.677654 13.7555 0.892157C14.1794 1.04844 14.5629 1.29786 14.8776 1.62204C15.2019 1.9369 15.4514 2.32049 15.6078 2.74455C15.823 3.32486 15.9366 3.93791 15.9435 4.55678C15.9906 5.58627 16.0002 5.89451 16.0002 8.50031C16.0002 11.1061 15.9906 11.4144 15.9435 12.4438C15.9361 13.0626 15.8225 13.6755 15.6078 14.2559C15.4455 14.6768 15.1967 15.059 14.8777 15.378C14.5587 15.6969 14.1764 15.9456 13.7555 16.1078C13.1751 16.323 12.5621 16.4366 11.9432 16.4435C10.9147 16.4906 10.6055 16.5002 7.99969 16.5002C5.39388 16.5002 5.08565 16.4911 4.0571 16.4435"
        fill="url(#paint0_radial_193_33980)" />
      <path
        d="M4.05725 16.4434C3.43839 16.4365 2.82534 16.323 2.24502 16.1078C1.82125 15.9512 1.43784 15.7018 1.12282 15.378C0.798081 15.0636 0.548342 14.6801 0.392157 14.2559C0.177216 13.6756 0.0638717 13.0626 0.057098 12.4438C0.00956863 11.4151 0 11.1066 0 8.5C0 5.89341 0.0105098 5.58596 0.0566274 4.55647C0.0642231 3.93793 0.177707 3.32525 0.392157 2.74502C0.549103 2.32118 0.798488 1.93761 1.1222 1.6222C1.43682 1.29775 1.82041 1.04824 2.24455 0.892157C2.82487 0.677038 3.43792 0.563534 4.05678 0.556627C5.0858 0.509569 5.39482 0.5 8 0.5C10.6052 0.5 10.914 0.51051 11.9435 0.556627C12.5622 0.564169 13.1751 0.677654 13.7555 0.892157C14.1794 1.04844 14.5629 1.29786 14.8776 1.62204C15.2019 1.9369 15.4514 2.32049 15.6078 2.74455C15.823 3.32486 15.9366 3.93791 15.9435 4.55678C15.9906 5.58627 16.0002 5.89451 16.0002 8.50031C16.0002 11.1061 15.9906 11.4144 15.9435 12.4438C15.9361 13.0626 15.8225 13.6755 15.6078 14.2559C15.4455 14.6768 15.1967 15.059 14.8777 15.378C14.5587 15.6969 14.1764 15.9456 13.7555 16.1078C13.1751 16.323 12.5621 16.4366 11.9432 16.4435C10.9147 16.4906 10.6055 16.5002 7.99969 16.5002C5.39388 16.5002 5.08565 16.4911 4.0571 16.4435"
        fill="url(#paint1_radial_193_33980)" />
      <path
        d="M6.03549 8.53402C6.03552 8.14214 6.15176 7.75907 6.3695 7.43326C6.58725 7.10744 6.89672 6.85351 7.25878 6.70358C7.62084 6.55366 8.01924 6.51446 8.40357 6.59095C8.78791 6.66745 9.14094 6.85619 9.418 7.13332C9.69507 7.41046 9.88373 7.76353 9.96013 8.14789C10.0365 8.53224 9.99725 8.93063 9.84723 9.29265C9.69722 9.65468 9.44321 9.96409 9.11735 10.1818C8.79148 10.3994 8.40839 10.5156 8.01651 10.5155C7.49106 10.5154 6.98715 10.3066 6.61564 9.93502C6.24413 9.56342 6.03545 9.05947 6.03549 8.53402ZM4.96427 8.53402C4.96427 9.13769 5.14329 9.72781 5.47867 10.2298C5.81405 10.7317 6.29075 11.1229 6.84847 11.3539C7.40619 11.5849 8.01989 11.6454 8.61197 11.5276C9.20405 11.4098 9.7479 11.1191 10.1748 10.6923C10.6016 10.2654 10.8923 9.72156 11.0101 9.12948C11.1279 8.5374 11.0674 7.9237 10.8364 7.36598C10.6054 6.80825 10.2142 6.33156 9.71224 5.99617C9.2103 5.66079 8.62019 5.48178 8.01651 5.48178C7.61568 5.48176 7.21877 5.5607 6.84845 5.71408C6.47812 5.86746 6.14164 6.09228 5.85821 6.37571C5.57478 6.65914 5.34995 6.99563 5.19657 7.36595C5.04319 7.73628 4.96425 8.13319 4.96427 8.53402ZM10.4763 5.36084C10.4762 5.50191 10.518 5.63983 10.5963 5.75716C10.6746 5.87449 10.786 5.96595 10.9163 6.02C11.0466 6.07404 11.19 6.08823 11.3284 6.06077C11.4667 6.03331 11.5939 5.96543 11.6937 5.86572C11.7935 5.76602 11.8614 5.63896 11.889 5.50061C11.9166 5.36227 11.9025 5.21885 11.8486 5.08849C11.7947 4.95814 11.7033 4.84671 11.5861 4.76828C11.4688 4.68986 11.3309 4.64796 11.1898 4.6479C11.0008 4.64798 10.8194 4.72311 10.6857 4.85679C10.552 4.99047 10.4768 5.17175 10.4766 5.36084M5.61541 13.3724C5.23849 13.3683 4.86509 13.2993 4.51157 13.1685C4.25519 13.0697 4.02234 12.9183 3.82801 12.7241C3.63368 12.5298 3.48218 12.297 3.38325 12.0407C3.25239 11.6872 3.18341 11.3138 3.17933 10.9368C3.15047 10.3103 3.14482 10.1221 3.14482 8.5348C3.14482 6.94751 3.1511 6.75974 3.17933 6.13261C3.18391 5.75573 3.25287 5.3824 3.38325 5.02876C3.48206 4.7723 3.63352 4.5394 3.82786 4.34506C4.0222 4.15072 4.25511 3.99926 4.51157 3.90045C4.86507 3.76959 5.23848 3.70061 5.61541 3.69653C6.24192 3.66767 6.43016 3.66202 8.01682 3.66202C9.60349 3.66202 9.79188 3.66814 10.419 3.69669C10.7959 3.70126 11.1692 3.77022 11.5229 3.90061C11.7793 3.99943 12.0122 4.15089 12.2066 4.34522C12.4009 4.53956 12.5524 4.77246 12.6512 5.02892C12.782 5.38243 12.851 5.75584 12.8551 6.13276C12.884 6.76022 12.8896 6.94751 12.8896 8.53496C12.8896 10.1224 12.8838 10.31 12.8551 10.9372C12.8507 11.3141 12.7817 11.6874 12.6512 12.041C12.5522 12.2973 12.4007 12.5301 12.2064 12.7244C12.0121 12.9186 11.7792 13.07 11.5229 13.1688C11.1694 13.2997 10.7959 13.3687 10.419 13.3728C9.79251 13.4016 9.60427 13.4073 8.01682 13.4073C6.42937 13.4073 6.24176 13.4015 5.61541 13.3728M5.56616 2.62625C5.07295 2.63595 4.58497 2.7293 4.12302 2.90233C3.72812 3.05501 3.36948 3.28854 3.0701 3.58792C2.77071 3.8873 2.53719 4.24594 2.38451 4.64084C2.2115 5.1028 2.11815 5.59078 2.10843 6.08398C2.0791 6.7177 2.07251 6.92037 2.07251 8.53464C2.07251 10.1489 2.07926 10.3514 2.10843 10.9853C2.11815 11.4785 2.2115 11.9665 2.38451 12.4284C2.5372 12.8233 2.77073 13.182 3.07011 13.4814C3.36949 13.7807 3.72812 14.0143 4.12302 14.167C4.585 14.3399 5.07296 14.4333 5.56616 14.443C6.2002 14.4719 6.40255 14.479 8.01682 14.479C9.6311 14.479 9.83361 14.4722 10.4675 14.443C10.9607 14.4333 11.4487 14.3399 11.9106 14.167C12.3055 14.0143 12.6642 13.7807 12.9635 13.4814C13.2629 13.182 13.4964 12.8233 13.6491 12.4284C13.8224 11.9665 13.9157 11.4785 13.9252 10.9853C13.9541 10.3511 13.9607 10.1489 13.9607 8.53464C13.9607 6.92037 13.9539 6.71786 13.9252 6.08398C13.9155 5.59078 13.8222 5.1028 13.6491 4.64084C13.4965 4.24601 13.263 3.88743 12.9637 3.58806C12.6644 3.28868 12.3059 3.05512 11.9111 2.90233C11.4492 2.72919 10.9612 2.63584 10.468 2.62625C9.83408 2.59723 9.63157 2.59033 8.01761 2.59033C6.40365 2.59033 6.20066 2.59708 5.56647 2.62625"
        fill="white" />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_193_33980"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1.03545 16.1496) scale(20.314)">
        <stop offset="0.09" stop-color="#FA8F21" />
        <stop offset="0.78" stop-color="#D82D7E" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_193_33980"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.0827 15.6357) scale(17.8765)">
        <stop offset="0.64" stop-color="#D300C5" stop-opacity="0" />
        <stop offset="1" stop-color="#D300C5" />
      </radialGradient>
      <clipPath id="clip0_193_33980">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #tiktok>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_193_34012)">
      <path
        d="M13.0546 5.23089V5.15178C12.3546 5.15178 11.7088 4.92023 11.1888 4.53089C11.2359 4.59356 11.2848 4.65489 11.3364 4.714C11.8293 5.04023 12.4195 5.23089 13.0546 5.23089ZM6.12839 12.4002C7.12039 12.4002 7.9275 11.5931 7.9275 10.6011L7.94394 9.018V8.93889L7.9275 10.522C7.9275 11.514 7.12039 12.3211 6.12839 12.3211C5.79372 12.3211 5.48083 12.2291 5.21239 12.0696C5.23772 12.1122 5.26483 12.1536 5.29372 12.194C5.54305 12.3256 5.82705 12.4002 6.12839 12.4002ZM9.93728 2.11312C9.93728 2.17712 9.93905 2.24112 9.94306 2.30423C9.95061 2.426 9.96572 2.54556 9.98661 2.66334H10.0013C9.97194 2.52067 9.95239 2.37445 9.9435 2.22556C9.9395 2.16245 9.93772 2.09845 9.93772 2.03445V2.03223H7.94439V2.11134H9.93772V2.11312H9.93728ZM6.12839 6.78645C6.32305 6.78645 6.51417 6.80112 6.70039 6.82912L6.70261 7.33978H6.70305L6.70039 6.75045C6.51372 6.72245 6.32261 6.70778 6.12839 6.70778C4.02172 6.70778 2.31372 8.41578 2.31372 10.5224C2.31372 10.5358 2.31417 10.5487 2.31417 10.562C2.3355 8.47312 4.03505 6.78645 6.12839 6.78645Z"
        fill="#25F4EE" />
      <path
        d="M2.31417 10.5615C2.31417 10.5749 2.31372 10.5877 2.31372 10.6011C2.31372 11.8971 2.96039 13.042 3.94839 13.7313C3.88483 13.662 3.82394 13.5904 3.76528 13.5166C2.89061 12.826 2.32661 11.7597 2.31417 10.5615Z"
        fill="#25F4EE" />
      <path
        d="M3.76541 13.5165C3.25207 12.8667 2.94541 12.0458 2.94541 11.1534C2.94541 9.06582 4.62274 7.36982 6.70363 7.33916L6.70141 6.82849C6.51474 6.80049 6.32363 6.78582 6.12941 6.78582C4.03607 6.78582 2.33652 8.47249 2.31519 10.5609C2.32674 11.7596 2.89074 12.8258 3.76541 13.5165ZM13.0547 5.71827V5.23027C12.4196 5.23027 11.829 5.0396 11.3365 4.71338C11.7761 5.21782 12.3752 5.57871 13.0547 5.71827Z"
        fill="#25F4EE" />
      <path
        d="M7.92744 10.6011C7.92744 11.5931 7.12032 12.4002 6.12832 12.4002C5.82699 12.4002 5.54299 12.3255 5.29321 12.194C5.61944 12.6526 6.15499 12.9526 6.75944 12.9526C7.75144 12.9526 8.55855 12.1455 8.55855 11.1535L8.57499 9.5704V2.66328H9.98655C9.96566 2.54551 9.95055 2.42595 9.94299 2.30417C9.93899 2.24106 9.93721 2.17706 9.93721 2.11306V2.11084H7.94388V8.93928V9.0184L7.92744 10.6011Z"
        fill="#25F4EE" />
      <path
        d="M13.0546 5.71826V7.14004V7.21915L13.0084 7.21782C11.8933 7.19426 10.8164 6.80626 9.94307 6.11293V10.5218V10.6009C9.94307 11.1334 9.83373 11.6409 9.6364 12.1014C9.05329 13.4623 7.70218 14.4156 6.12795 14.4156C5.31729 14.4156 4.56573 14.1623 3.94751 13.7312C4.64484 14.4912 5.64618 14.968 6.75907 14.968C8.33329 14.968 9.6844 14.0147 10.2675 12.6538C10.4644 12.1934 10.5742 11.6858 10.5742 11.1534V6.66582C11.4475 7.35915 12.5244 7.74715 13.6395 7.77071L13.6857 7.77204V5.78315C13.4697 5.78315 13.2586 5.76048 13.0546 5.71826Z"
        fill="#FE2C55" />
      <path
        d="M6.71012 8.8182L6.71057 8.89731C6.61012 8.86309 6.50657 8.83775 6.40123 8.82175C6.3119 8.80842 6.22034 8.80175 6.12879 8.80175C5.14968 8.80175 4.3519 9.58753 4.33057 10.5613C4.34434 11.2026 4.69501 11.7618 5.21234 12.0693C5.05279 11.8009 4.96079 11.4875 4.96079 11.1533C4.96079 10.1613 5.7679 9.3542 6.7599 9.3542C6.85145 9.3542 6.94301 9.36086 7.03234 9.3742C7.13812 9.3902 7.24123 9.41509 7.34168 9.44975L7.3319 7.38131C7.14523 7.35331 6.95412 7.33864 6.7599 7.33864C6.74123 7.33864 6.72212 7.33909 6.70345 7.33953L6.71012 8.8182ZM11.1888 4.53064C10.8355 4.0582 10.6123 3.48264 10.5746 2.85642C10.5706 2.79331 10.5688 2.72931 10.5688 2.66531V2.66309H10.0012C10.1568 3.42309 10.5897 4.0822 11.1888 4.53064Z"
        fill="#FE2C55" />
      <path
        d="M11.3364 4.71375C11.2848 4.65464 11.2359 4.59331 11.1888 4.53064C10.5897 4.0822 10.1568 3.42309 10.0012 2.66309H9.98657C10.139 3.5182 10.639 4.25197 11.3364 4.71375Z"
        fill="#25F4EE" />
      <path
        d="M6.71024 8.81802L6.71068 8.81847L6.70357 7.33936H6.70312L6.71024 8.81802Z"
        fill="black" />
      <path
        d="M4.33071 10.5613C4.33027 10.5746 4.32983 10.5875 4.32983 10.6008C4.32983 11.2915 4.72138 11.8924 5.29383 12.1937C5.26538 12.1533 5.23783 12.112 5.21249 12.0693C4.69471 11.7622 4.34449 11.2026 4.33071 10.5613ZM9.94316 6.03418V6.11329C10.8165 6.80662 11.8934 7.19462 13.0085 7.21818L13.0547 7.21951V7.1404L13.0085 7.13907C11.8938 7.11551 10.8169 6.72796 9.94316 6.03418ZM9.63694 12.1013C9.83383 11.6408 9.9436 11.1333 9.9436 10.6008V10.5217C9.9436 11.0542 9.83427 11.5617 9.63694 12.0222C9.05382 13.3831 7.70271 14.3364 6.12849 14.3364C5.23605 14.3364 4.41516 14.0297 3.76538 13.5164C3.8236 13.5902 3.88494 13.6617 3.94849 13.7311C4.56671 14.1622 5.31782 14.4155 6.12894 14.4155C7.70271 14.4155 9.05382 13.4622 9.63694 12.1013Z"
        fill="white" />
      <path
        d="M6.12846 8.72314C5.13646 8.72314 4.32935 9.53026 4.32935 10.5223C4.32935 10.5356 4.33023 10.5485 4.33023 10.5618C4.35157 9.58803 5.14935 8.80226 6.12846 8.80226C6.22001 8.80226 6.31157 8.80892 6.4009 8.82226C6.50668 8.83826 6.60979 8.86314 6.71023 8.89781L6.70979 8.8187C6.60935 8.78448 6.50623 8.75959 6.4009 8.74359C6.31201 8.72981 6.22001 8.72314 6.12846 8.72314Z"
        fill="white" />
      <path
        d="M11.3363 4.71375C10.639 4.25197 10.139 3.5182 9.98656 2.66309H8.575V9.5702L8.55856 11.1533C8.55856 12.1453 7.75145 12.9524 6.75945 12.9524C6.155 12.9524 5.61945 12.6524 5.29322 12.1938C4.72078 11.8924 4.32922 11.2915 4.32922 10.6009C4.32922 10.5875 4.33011 10.5746 4.33011 10.5613C4.32967 10.548 4.32922 10.5351 4.32922 10.5218C4.32922 9.52975 5.13634 8.72264 6.12834 8.72264C6.21989 8.72264 6.31145 8.72931 6.40078 8.74264C6.50611 8.75864 6.60967 8.78353 6.70967 8.81775L6.70256 7.33864C4.62211 7.36886 2.94434 9.06486 2.94434 11.1529C2.94434 12.0453 3.251 12.8662 3.76434 13.516C4.41411 14.0298 5.235 14.336 6.12745 14.336C7.70167 14.336 9.05278 13.3826 9.63589 12.0218C9.83278 11.5613 9.94256 11.0538 9.94256 10.5213V6.11242V6.03331C10.8159 6.72664 11.8928 7.11464 13.0079 7.1382L13.0541 7.13953V5.71775C12.375 5.57864 11.7759 5.21775 11.3363 4.71375Z"
        fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_193_34012">
        <rect y="0.5" width="16" height="16" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
<!-- END Logo empresas -->

<!-- Tooltip templates -->
<ng-template #tooltip1>
  <div class="tooltip-light">
    <p>
      Os direitos em oferta representam as participações nos ganhos de uma obra
      musical e podem ser de três tipos: fonográficos (gravação da música),
      autorais (composição) e royalties (uso em plataformas digitais e outros
      canais).
    </p>
  </div>
</ng-template>

<ng-template #tooltip2>
  <div class="tooltip-light">
    <p>
      O período durante o qual os royalties ou direitos adquiridos estarão
      vigentes. Após o vencimento, os royalties voltam a ser pagos aos
      proprietários originais dos direitos.
    </p>
  </div>
</ng-template>

<ng-template #tooltip3>
  <div class="tooltip-light">
    <p>
      A porcentagem específica de direitos econômicos que cada token individual
      representa.
    </p>
  </div>
</ng-template>

<ng-template #tooltip4>
  <div class="tooltip-light tooltip-light--with-link">
    <p>
      Royalties de execução pública são valores pagos aos compositores e
      editores sempre que suas músicas são tocadas em rádios, TVs, shows,
      eventos, ou estabelecimentos comerciais. O ECAD arrecada essas taxas e
      distribui os valores por meio de associações de gestão coletiva.
    </p>
    <a
      target="_blank"
      href="https://magroove.com/blog/pt-br/direito-de-execucao/">
      Saber mais
    </a>
  </div>
</ng-template>

<ng-template #tooltip5>
  <div class="tooltip-light tooltip-light--with-link">
    <p>
      Royalties de streaming são os ganhos obtidos cada vez que uma música é
      reproduzida em plataformas digitais como Spotify e YouTube. A receita,
      proveniente de assinaturas e publicidade, é dividida entre compositores,
      intérpretes e produtores. Deste total, 12,75% vai para os detentores dos
      direitos autorais e 87,25% para os demais detentores de direitos.
    </p>
    <a
      target="_blank"
      href="https://magroove.com/blog/pt-br/direitos-fonomecanicos/">
      Saber mais
    </a>
  </div>
</ng-template>

<ng-template #tooltip6>
  <div class="tooltip-light tooltip-light--right">
    <p>
      <strong>Associações de gestão coletiva:</strong>
      Entidades que representam compositores, editores e outros titulares,
      administrando e distribuindo os royalties arrecadados pelo ECAD para
      garantir que cada artista receba sua parte de forma justa e precisa.
    </p>
  </div>
</ng-template>

<ng-template #tooltip7>
  <div class="tooltip-light tooltip-light--right">
    <p>
      <strong>Rubricas de pagamento do ECAD:</strong>
      Categorias que classificam o tipo de execução pública de uma obra (como
      rádio, TV, streaming ou shows) e definem como a receita arrecadada será
      distribuída entre compositores, editores e outros titulares.
    </p>
    <a
      target="_blank"
      href="https://magroove.com/blog/pt-br/direitos-fonomecanicos/">
      Saber mais
    </a>
  </div>
</ng-template>
<!-- END Tooltip templates -->
